import React from 'react'
import { Tooltip } from 'antd'
import { InfoIcon as II } from '@/style-guide'

export const InfoIcon = ({ text }) => (
  <Tooltip
    title={text}
    color="#fff"
    overlayInnerStyle={{
      color: '#000',
      border: '1px solid #ddd',
      padding: '15px',
    }}
  >
    <II />
  </Tooltip>
)
